import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LangContext";
import LanguageSwitcher from "./LanguageSwitcher";

export const Footer = () => {
  const { lang, t } = useLang();
  return (
    <footer className="mt-24 border-t border-border/70" data-testid="site-footer">
      <div className="mx-auto max-w-[1180px] px-5 sm:px-8 py-12 grid gap-8 sm:grid-cols-3 items-start">
        <div>
          <div className="font-serif-display text-2xl tracking-[0.04em]">{t("footer.lineOne")}</div>
          <div className="editorial-kicker mt-3">{t("footer.lineTwo")}</div>
        </div>
        <nav className="grid grid-cols-2 gap-x-8 gap-y-2 text-[12px] tracking-[0.18em] uppercase text-foreground/55" aria-label="Footer">
          <Link to={`/${lang}/story`} className="hover:text-foreground" data-testid="footer-story-link">{t("nav.story")}</Link>
          <Link to={`/${lang}/schedule`} className="hover:text-foreground" data-testid="footer-schedule-link">{t("nav.schedule")}</Link>
          <Link to={`/${lang}/travel`} className="hover:text-foreground" data-testid="footer-travel-link">{t("nav.travel")}</Link>
          <Link to={`/${lang}/rsvp`} className="hover:text-foreground" data-testid="footer-rsvp-link">{t("nav.rsvp")}</Link>
          <Link to={`/${lang}/gallery`} className="hover:text-foreground" data-testid="footer-gallery-link">{t("nav.gallery")}</Link>
          <Link to={`/${lang}/upload`} className="hover:text-foreground" data-testid="footer-upload-link">{t("nav.upload")}</Link>
          <Link to={`/${lang}/guestbook`} className="hover:text-foreground" data-testid="footer-guestbook-link">{t("nav.guestbook")}</Link>
          <Link to={`/${lang}/gifts`} className="hover:text-foreground" data-testid="footer-gifts-link">{t("nav.gifts")}</Link>
          <Link to={`/${lang}/dj`} className="hover:text-foreground" data-testid="footer-dj-link">{t("nav.dj")}</Link>
          <Link to={`/${lang}/faq`} className="hover:text-foreground" data-testid="footer-faq-link">{t("nav.faq")}</Link>
        </nav>
        <div className="flex flex-col gap-3 items-start sm:items-end">
          <LanguageSwitcher />
          <p className="editorial-kicker max-w-[24ch] sm:text-right">{t("footer.lineThree")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
